import { defineStore } from 'pinia';
import { iStoreUI, tCaseMenuCategory, tLeftSidebarTabs, tModalName } from '@/Interfaces/storeUI';
import { onStoreUiUpdateHandlerThrottled } from '@/Engine/eventHandlers/onStoreUiUpdate';

export const useStoreUI = defineStore('storeUI', {
    state: () : iStoreUI => ({
        leftSidebarTab: 'case',
        caseMenuCategory: [ 'template' ],
        isSelectCase: true,
        isShowModal: false,
        activeModalName: 'unsavedCaseAlert',
        dndItem: null,
        isCursorOutsideToolChest: true,
        pointerPosition: { x:0,y:0 },
        shownTopColorMenu: undefined,
        isMobile: false,
        isGuide: false,
        isContextMenuAvailable: false,
        isMobileLoader: false,
        isSelectedModel: false,
    }),
    getters: {
        // getSelectedSceneObject: (state) => {
        //     return state.selectedSceneObject;
        // },
        // getUIPosition: (state) => {
        //     return (name: string) => {
        //         return state.positions[name];
        //     };
        // },
    },
    actions: {
        setIsMobile(status: boolean) {
            this.isMobile = status;
        },
        setShownTopColorMenu(value?: undefined | 'colorFrame'| 'colorFace') {
            this.shownTopColorMenu = value;
        },
        setDndItem(value: string|null, isUpdateStore = true) {
          this.dndItem = value;
          if (isUpdateStore) onStoreUiUpdateHandlerThrottled();
        },
        setLeftSidebarTab(value: tLeftSidebarTabs) {
            this.leftSidebarTab = value;
        },
        setCaseMenuCategory(value: Array<tCaseMenuCategory>) {
            this.caseMenuCategory = value;
        },
        setIsSelectCase(status: boolean) {
            this.isSelectCase = status;
        },
        setIsShowModal(status: boolean) {
            this.isShowModal = status;
        },
        setActiveModalName(name: tModalName) {
            this.activeModalName = name;
        },
        setIsCursorOutsideToolChest(value: boolean) {
            this.isCursorOutsideToolChest = value;
        },
        setPointerPosition(x:number,y:number){
            this.pointerPosition.x=x;
            this.pointerPosition.y=y;
        },
        setIsGuide(status: boolean) {
            this.isGuide = status;
        },
        setIsContestMenuAvailable(status: boolean) {
            this.isContextMenuAvailable = status;
        },
        setIsMobileLoader(status: boolean) {
            this.isMobileLoader = status;
        },
    },
});
